module.exports = __webpack_public_path__ + "static/media/img10.260c7984.svg";